export const DEFAULT_ENDPOINT = '/graphql'
export const TM_ENDPOINT = '/tm/graphql'

/** @deprecated */
export const MYPAGE_ENDPOINT = '/mypage/graphql'
